/** Shared styles + micro-components for the General Process designer.
    Mirrors the visual designer's idiom (inline styles over CSS variables). */

import type React from 'react'

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '5px 7px',
  fontSize: 14,
  border: '1px solid var(--color-border)',
  borderRadius: 4,
  background: 'var(--color-bg-secondary)',
  color: 'var(--color-text)',
}

export const selectStyle: React.CSSProperties = { ...inputStyle }

export const monoAreaStyle: React.CSSProperties = {
  width: '100%',
  minHeight: 160,
  fontFamily: 'monospace',
  fontSize: 13,
  padding: 8,
  background: 'var(--color-bg-secondary)',
  color: 'var(--color-text)',
  border: '1px solid var(--color-border)',
  borderRadius: 4,
  resize: 'vertical',
}

export const hintStyle: React.CSSProperties = {
  fontSize: 13,
  color: 'var(--color-text-secondary)',
  marginTop: 4,
  lineHeight: 1.5,
}

export const emptyHintStyle: React.CSSProperties = {
  fontSize: 13,
  color: 'var(--color-text-secondary)',
  opacity: 0.7,
  padding: '8px 4px',
}

export const cardStyle: React.CSSProperties = {
  border: '1px solid var(--color-border)',
  borderRadius: 'var(--radius-md)',
  background: 'var(--color-bg)',
  padding: 12,
  marginBottom: 12,
}

export const thStyle: React.CSSProperties = {
  textAlign: 'left',
  padding: '6px 8px',
  fontSize: 13,
  textTransform: 'uppercase',
  letterSpacing: 0.4,
  color: 'var(--color-text-secondary)',
  borderBottom: '1px solid var(--color-border)',
  whiteSpace: 'nowrap',
  position: 'sticky',
  top: 0,
  background: 'var(--color-bg)',
  zIndex: 1,
}

export const tdStyle: React.CSSProperties = {
  padding: '4px 8px',
  fontSize: 13.5,
  borderBottom: '1px solid var(--color-border)',
  whiteSpace: 'nowrap',
  maxWidth: 280,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export function SectionHeader({
  children, right,
}: { children: React.ReactNode; right?: React.ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 13,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        color: 'var(--color-text-secondary)',
        marginTop: 4,
        marginBottom: 6,
      }}
    >
      <span>{children}</span>
      {right}
    </div>
  )
}

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 3 }}>
        {label}
      </div>
      {children}
    </div>
  )
}
